// FullScreenLoader.jsx
import React from "react";
import { ClockLoader } from "react-spinners";

const FullScreenLoader = () => {
  return (
    <div style={styles.overlay}>
      <ClockLoader color="#2563eb" size={60} />
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.8)", // optional backdrop
    zIndex: 9999,
  },
};

export default FullScreenLoader;